export class ObjectFieldSetting {
    Id: number;
    Tenant: number;
    ObjectFieldCode: string;
    ObjectTableCode: string;
    EnableGroupBy: boolean;
    IsPermissionAllowed : boolean;
}